import "./Top.css";
export const Top = () => {
  return (
    <>
      <div className="top">
        <div className="top-div-img">
          <img
            src="https://img.huffingtonpost.com/asset/6234c16a2100003d48504110.jpg?ops=800_450&format=webp"
            alt=""
            className="top-img"
          />
        </div>
        <div className="top-div-title">
            <h4 className="title">FOOD & DRINK</h4>
            <h1 className="heading">Nutrition Experts Share 7 Healthy Breakfasts That Cost Less Than $1</h1>
        </div>
      </div>
    </>
  );
};
